const baseUrl = '/api/customer/user'

export default {
    get(userId, where, order, page) {
        let params = []

        if (where) {
            params.push(`where=${encodeURIComponent(JSON.stringify(where))}`)
        }

        if (order) {
            params.push(`order=id:${order}`)
        }

        if (page) {
            params.push('page=' + page)
        }

        return axios.get(`${baseUrl}/${userId}/product?${params.join('&')}`)
    },

    find(userId, productId) {
        return axios.get(`${baseUrl}/${userId}/product/${productId}`)
    },

    list(userId) {
        return axios.get(`${baseUrl}/${userId}/product`)
    },

    async byType(userId, type, order) {
        const { data: { data: products } } = await this.get(userId, {
            type,
            is_active: true,
        }, order)

        return products
    },

    async firstOfType(userId, type) {
        return (await this.byType(userId, type)).shift()
    }
}
